/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartnerRelationshipKind } from './partnerRelationshipKind';

/**
 * Relationship of another partner, according to this partner. Example: In case of relationship kind *Child*, the related partner is the child of this partner.   (bipro-partner::Partnerbeziehung)
 */
export interface PartnerRelationship {
  /**
   * Unique identification of a partner within the scope of the request/response object.   Every partner object must define a partner ID.   Every partner role may reference a corresponding partner object.   Values can be choosen freely, but must be unique in the request/response object.
   */
  partnerId: string;
  relationshipKind: PartnerRelationshipKind;
}
export namespace PartnerRelationship {}
